<template>
  <cbm-card
    title="Primeiras compras"
    :number-text="value"
    :percent-text="percentageText"
    percent-description="do total de primeiras compras"
    tooltip="Total de consumidores que compraram algum desses produtos pela primeira vez dentro da mensuração da campanha"
    simple-card
    :boolean-loader="loading"
  />
</template>

<script>
import CbmCard from '@/components/CbmCard.vue'
import { localeString } from '@/config/helpers.js'

export default {
  name: 'ResultsFirstPurchaseCard',
  components: {
    CbmCard,
  },
  props: {
    metrics: Object,
    loading: Boolean,
  },
  computed: {
    firstPurchaseMetrics() {
      return this.metrics?.first_purchase_metrics
    },
    value() {
      if (this.$getLoggedUser().only_mercapromo) return localeString(0, 0)
      return localeString(this.firstPurchaseMetrics?.count_with_sales || 0, 0)
    },
    percentageText() {
      if (this.$getLoggedUser().only_mercapromo) return '0%'
      return `${localeString(
        this.firstPurchaseMetrics?.count_total ? (this.firstPurchaseMetrics?.count_with_sales / this.firstPurchaseMetrics?.count_total) * 100 : 0,
        2
      )}%`
    },
  },
}
</script>
